<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <template v-slot:title>New Search</template>
    <v-row>
      <v-col
        ><v-text-field
          label="Supplier Name/Code Filter"
          v-model="supplierNameFilter"
          :outlined="outlinedInputs"
          hide-details
          clearable
          dense
        ></v-text-field></v-col
      ><v-col
        ><v-text-field
          label="Service Name/Code Filter"
          v-model="serviceNameFilter"
          :outlined="outlinedInputs"
          hide-details
          clearable
          dense
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row justify="center" align="baseline">
      <v-radio-group
        v-if="multiSupplierTypes"
        v-model="selectedSupplierTypes"
        row
        :disabled="$apollo.loading"
        class="ma-0 py-0"
        multiple
        dense
        hide-details
      >
        <v-radio
          v-for="sType in supplierTypes"
          :key="sType"
          :value="sType"
          @click="onSupplierTypeClick(sType)"
          dense
          hide-details
        >
          <template v-slot:label>
            <v-icon left>{{ supplierTypeIcon(sType) }}</v-icon>
          </template>
        </v-radio>
      </v-radio-group>
      <v-radio-group
        v-else
        v-model="selectedSupplierType"
        row
        @change="onServiceTypeChange"
        class="ma-0 py-0"
        dense
        hide-details
      >
        <v-radio
          v-for="sType in supplierTypes"
          :key="sType"
          :value="sType"
          dense
          hide-details
        >
          <template v-slot:label>
            <v-icon left>{{ supplierTypeIcon(sType) }}</v-icon>
          </template>
        </v-radio>
      </v-radio-group>
    </v-row>
    <v-row>
      <v-col>
        <dates-range-picker
          :gtDateFromString="startDate"
          :gtDateToString="endDate"
          :rangeStart="dateRangeStart"
          :rangeEnd="dateRangeEnd"
          @onRangeSelected="onDateRangeSelected"
          :outlined="outlinedInputs"
          dense
        ></dates-range-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          :outlined="outlinedInputs"
          dense
          hide-details
          label="Adults"
          type="number"
          v-model="adults"
        />
      </v-col>
      <v-col>
        <v-text-field
          :outlined="outlinedInputs"
          dense
          hide-details
          label="Children"
          type="number"
          v-model="children"
        />
      </v-col>
      <v-col>
        <v-text-field
          :outlined="outlinedInputs"
          dense
          hide-details
          label="Infants"
          type="number"
          v-model="infants"
        />
      </v-col>
    </v-row>
    <v-row
      ><v-col>
        <destination-list-select
          v-model="destinationId"
          :outlined="outlinedInputs"
          hide-details
          dense
        ></destination-list-select> </v-col
      ><v-col>
        <provider-list-select
          v-model="providers"
          :outlined="outlinedInputs"
          dense
          hideDetails
        />
      </v-col>
    </v-row>
    <v-row v-if="showPickupDropoffForThompsons">
      <v-col>
        <thompsons-place-list-select
          v-model="customParams.pickupPoint"
          :outlined="outlinedInputs"
          dense
          hide-details
          label="Pickup Point"
          :destination-id="destinationId"
        />
      </v-col>
      <v-col>
        <thompsons-place-list-select
          v-model="customParams.dropoffPoint"
          :outlined="outlinedInputs"
          dense
          hide-details
          label="Dropoff Point"
          :destination-id="destinationId"
        />
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col>
        <v-switch
          v-model="multiSupplierTypes"
          label="Multi"
          class="my-0 py-0"
          @change="onMultiSFRChange"
          hide-details
          dense
        ></v-switch>
      </v-col>
      <v-col>
        <v-switch
          v-model="includeUnpriced"
          label="Include Unpriced"
          class="ml-2 my-0 py-0"
          hide-details
          dense
        ></v-switch>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onStart" dense class="ma-0"
        ><v-icon left>mdi-magnify</v-icon>Start Search</v-btn
      >
    </template>
    <v-row v-if="debug">
      <v-col>
        <code>{{ customParams }}</code>
        <code>{{ providers }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog.vue";
import DatesRangePicker from "../../../shared/DatesRangePicker.vue";
import DestinationListSelect from "../../../shared/DestinationListSelect.vue";
import ProviderListSelect from "../../../shared/ProviderListSelect.vue";
import { SUPPLIER_TYPES } from "../../../../../constants/supplierTypes";
import { SupplierTypeIconMixin } from "../../../../../mixins/SupplierTypeIconMixin";
import ThompsonsPlaceListSelect from "../../../shared/ThompsonsPlaceListSelect.vue";
export default {
  name: "rate-search-params-dialog",

  components: {
    BasicDialog,
    DatesRangePicker,
    DestinationListSelect,
    ProviderListSelect,
    ThompsonsPlaceListSelect,
  },

  mixins: [SupplierTypeIconMixin],

  props: {
    value: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      supplierNameFilter: this.value ? this.value.supplierNameFilter : "",
      serviceNameFilter: this.value ? this.value.serviceNameFilter : "",
      startDate: this.value ? this.value.startDate : "",
      dateRangeStart: this.value ? this.value.startDate : "",
      dateRangeEnd: this.value ? this.value.endDate : "",
      endDate: this.value ? this.value.endDate : "",
      adults: this.value ? this.value.adults : 2,
      children: this.value ? this.value.children : 0,
      infants: this.value ? this.value.infants : 2,
      destinationId: this.value ? this.value.destinationId : "",
      customParams: this.value ? this.value.customParams : {},

      selectedSupplierType: this.supplierType
        ? this.supplierType
        : "ACCOMMODATION",
      providers:
        this.value && this.value.providers
          ? [...this.value.providers]
          : ["GTWEB", "GTWEB_MP", "BENTRAL", "RESREQUEST"],
      selectedSupplierTypes:
        this.value && this.value.serviceTypes
          ? [...this.value.serviceTypes]
          : ["ACCOMMODATION"],
      multiSupplierTypes: this.$store.getters.localSettings("multiSFR", false),
      supplierTypes: SUPPLIER_TYPES,
      includeUnpriced: false,
    };
  },

  computed: {
    showPickupDropoffForThompsons() {
      return (
        this.providers.includes("THOMPSONS_AFRICA") &&
        this.selectedSupplierTypes.includes("TRANSPORT")
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onDateRangeSelected(payload) {
      this.startDate = payload.dateFrom;
      this.endDate = payload.dateTo;
    },
    onSupplierTypeClick(sType) {
      if (this.selectedSupplierTypes.indexOf(sType) > -1) {
        this.selectedSupplierTypes = [
          ...this.selectedSupplierTypes.filter((t) => t != sType),
        ];
      } else {
        this.selectedSupplierTypes.push(sType);
      }
    },
    onServiceTypeChange(payload) {
      //console.log("onServiceTypeChange: ", payload);
      this.selectedSupplierTypes = [payload];
    },
    onMultiSFRChange() {
      this.$store.dispatch("updateLocalSettings", {
        multiSFR: this.multiSupplierTypes,
      });
    },
    onStart() {
      //console.log("starting new search");
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        startDate: this.startDate,
        endDate: this.endDate,
        serviceTypes: this.selectedSupplierTypes,
        destinationId: this.destinationId,
        serviceName: this.serviceNameFilter,
        supplierName: this.supplierNameFilter,
        providers: this.providers,
        includeUnpriced: this.includeUnpriced,
        multiSFR: this.multiSFR,
        adults: parseInt(this.adults),
        children: parseInt(this.children),
        infants: parseInt(this.infants),
        customParams: JSON.stringify(this.customParams),
      });
    },
  },

  watch: {
    value(newVal) {
      this.startDate = newVal.startDate;
      this.endDate = newVal.endDate;
      this.dateRangeStart = newVal.startDate;
      this.dateRangeEnd = newVal.endDate;
      this.serviceNameFilter = newVal.serviceName;
      this.supplierNameFilter = newVal.supplierName;
      this.adults = newVal.adults;
      this.children = newVal.children;
      this.infants = newVal.infants;
      this.destinationId = newVal.destinationId;
      this.providers = newVal.providers;
      this.selectedSupplierTypes = [...newVal.serviceTypes];
      this.selectedSupplierType = newVal.serviceTypes[0];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/rates-search/RateSearchParamsDialog.vue